// extracted by mini-css-extract-plugin
export default {"root":"_39s-gKOoSZwEYLAPadblvZ","stars":"_242aOAw7SqicIjsDusBFJ2","border":"_3KRnxY55n8cd7EB0rQy2l3"};